const dtGenerator = require("../../../../../components/dt/dt-generator");
const dtHandler = require("../../../../../components/dt/dt-handler");
const dtSearch = require("../../../../../components/dt/dt-search");
const dtReport = require("../../../../../components/dt/dt-report");
const customerProfitMenu = require("./customerProfit-menu");
const { organizeRow, tableDetail } = require("./customerProfit-dt-handler");
const customerProfitFetch = require("./customerProfit-fetch");

/****************ELEMENTS*****************/
let htmlDt = {};
let HTMLwasSelected = false;
let allData = [];
let asc = false;

function HTMLselect() {
  dtHandler.HTMLselect(
    "customerProfit-dt",
    htmlDt,
    organizeRow,
    tableDetail
  );
  HTMLwasSelected = true;
}
/****************ELEMENTS*****************/

export function start(detail) {
  if (!HTMLwasSelected) HTMLselect();
  obj[detail.act]?.start(detail);
}

const obj = {
  addRow: {
    start: (detail) => dtGenerator.addRow(detail, htmlDt),
  },
  updateRow: {
    start: (detail) => dtGenerator.updateRow(detail, htmlDt),
  },
  tableOptions: {
    start: (detail) => customerProfitMenu.start(detail, htmlDt, "htmlFc"),
  },
  trMenu: {
    start: (detail) => customerProfitMenu.start(detail, htmlDt, "htmlFc"),
  },
  filter: {
    start: (detail) => dtSearch.filter(detail, htmlDt),
  },
  filterShowHide: {
    start: (detail) => dtSearch.filterShowHide(detail, htmlDt),
  },
  loadMore: {
    start: (detail) => dtSearch.loadMore(detail, htmlDt),
  },
  searching: {
    start: (detail) => dtSearch.searching(detail, htmlDt),
  },
  select: {
    start: (detail) => dtSearch.select(detail, htmlDt, true),
  },

  fecthData: {
    start: (detail) => fecthData(detail),
  },
  loadMoreRows: {
    start: (detail) => dtReport.loadMoreRows(allData, htmlDt, organizeRow),
  },
  sortBy: {
    start: (detail) => sortBy(detail, htmlDt),
  },
  searchValue: {
    start: (detail) => searchValue(detail, htmlDt),
  },
};

function fecthData(detail) {
  const fetchDetail = {
    dest: "customer",
    elem: "report",
    reportType: "accountReceivableAll",
  };

  customerProfitFetch.fetchAll(fetchDetail, (data) => {
    if (!Array.isArray(data) || data.length === 0) {
      return;
    }

    //se puede pasar otro para definir la cantidad de filas por pagina
    //ejemplo: dtReport.organizeRowDtReport(data, htmlDt, organizeRow, 10); 
    dtReport.organizeRowDtReport(data, htmlDt, organizeRow);
    allData = data;
    fillColumns(data);
  });

}

function fillColumns(data) {
  const title = htmlDt.entityDt.querySelector('.title');
  const col1 = htmlDt.dtHeader.querySelector('.col-1');
  const col2 = htmlDt.dtHeader.querySelector('.col-2');
  const col3 = htmlDt.dtHeader.querySelector('.col-3');
  const col4 = htmlDt.dtHeader.querySelector('.col-4');
  const col5 = htmlDt.dtHeader.querySelector('.col-5');
  const col6 = htmlDt.dtHeader.querySelector('.col-6');
  const col7 = htmlDt.dtHeader.querySelector('.col-7');

  // Inicializar totales
  let last_24_h = 0;
  let last_7_d = 0;
  let last_15_d = 0;
  let last_30_d = 0;
  let last_90_d = 0;
  let over_90_d = 0;
  let total = 0;

  //Sumar todos los valores del parámetro
  data.forEach(element => {
    last_24_h += parseFloat((element.last_24_hours || '0').replace(/[^0-9.-]+/g, ""));
    last_7_d += parseFloat((element.last_7_days || '0').replace(/[^0-9.-]+/g, ""));
    last_15_d += parseFloat((element.last_15_days || '0').replace(/[^0-9.-]+/g, ""));
    last_30_d += parseFloat((element.last_30_days || '0').replace(/[^0-9.-]+/g, ""));
    last_90_d += parseFloat((element.last_90_days || '0').replace(/[^0-9.-]+/g, ""));
    over_90_d += parseFloat((element.over_90_days || '0').replace(/[^0-9.-]+/g, ""));
  });

  total = parseFloat(last_24_h + last_7_d + last_15_d + last_30_d + last_90_d + over_90_d).toFixed(2)

  title.innerHTML = '$' + total
  col1.innerHTML = '$' + total
  col2.innerHTML = '$' + last_24_h.toFixed(2)
  col3.innerHTML = '$' + last_7_d.toFixed(2)
  col4.innerHTML = '$' + last_15_d.toFixed(2)
  col5.innerHTML = '$' + last_30_d.toFixed(2)
  col6.innerHTML = '$' + last_90_d.toFixed(2)
  col7.innerHTML = '$' + over_90_d.toFixed(2)
}

function sortBy(detail, htmlDt) {
  const sortBy = detail.sortBy;
  const sortOrder = asc ? "asc" : "desc";
  asc = !asc;

  const fetchDetail = {
    dest: "customer",
    elem: "report",
    reportType: "accountReceivableAll",
    sort: {
      by: sortBy,
      dir: sortOrder,
    },
  };

  customerProfitFetch.fetchAll(fetchDetail, (data) => {
    if (!Array.isArray(data) || data.length === 0) return;

    dtReport.sortBy(data, htmlDt, organizeRow);
  });
}

function searchValue(detail, htmlDt) {
  const searchValue = detail.ev.target.value;

  const fetchDetail = {
    dest: "customer",
    elem: "report",
    reportType: "accountReceivableAll",
    search: searchValue,
  };

  customerProfitFetch.fetchAll(fetchDetail, (data) => {
    if (!Array.isArray(data) || data.length === 0) return;
    dtReport.searchValue(data, htmlDt, organizeRow);
  });
}
